<div>
    <div style="text-align: center">
      <div class="col-sm-12">
        <h3>{{title}}</h3>
      </div>
      
      <form [formGroup]="selectForm" >
        <div class="col-sm-12">
          <app-autocomplete-with-code-form 
          (objetChange)="updateSociety($event)"  
          name="society" [parent]="selectForm"  
          libelle="Societé" 
          [objets]="societyList" 
          [(objet)]="society">
          </app-autocomplete-with-code-form>
        </div>
        <div class="col-sm-12">
          <mat-form-field class="full-width">
            <mat-label>Type BC</mat-label>
            <mat-select formControlName="typeBc" (selectionChange)="updateTypeBc($event)">
              <mat-option *ngFor="let type of typesBc" [value]="type.value">{{ type.label }}</mat-option>
            </mat-select>
            <mat-error *ngIf="selectForm.get('typeBc')?.invalid">
              Veuillez sélectionner un type BC
            </mat-error>
          </mat-form-field>
        </div>    
      </form>

      <div class="col-sm-12">
        <mat-divider></mat-divider>
      </div>
      <div class="row">
        <div class="col-sm-6" style="margin-top: 40px;">
          <button mat-raised-button color="default" (click)="onModalCancel()">Annuler</button>
        </div>
        <div class="col-sm-6" style="margin-top: 40px;">
          <button mat-raised-button [color]="color" [disabled]="!this.selectForm.valid" (click)="onModalConfirm()" >Confirmer</button>
        </div>
      </div>
    </div>
  </div>